import { Input } from "@/components/ui/input";

// Format a raw numeric string (e.g. "3000.5") into "3,000.5" while preserving
// in-progress typing like "3000." so users can enter decimals naturally.
export const formatMoney = (raw) => {
  if (raw === "" || raw === null || raw === undefined) return "";
  const s = String(raw);
  const neg = s.startsWith("-");
  const [intPart, decPart] = s.replace("-", "").split(".");
  const fi = intPart === "" ? "" : Number(intPart || 0).toLocaleString("en-NG");
  let out = decPart !== undefined ? `${fi}.${decPart}` : fi;
  return neg ? `-${out}` : out;
};

// Monetary input with automatic thousands separators + up to `decimals` decimal places.
// Parent stores/receives the RAW numeric string via onValueChange (no commas).
export function MoneyInput({ value, onValueChange, decimals = 2, ...props }) {
  const handle = (e) => {
    let raw = e.target.value.replace(/,/g, "").replace(/[^\d.]/g, "");
    const parts = raw.split(".");
    if (parts.length > 2) raw = parts[0] + "." + parts.slice(1).join("");
    const [ip, dp] = raw.split(".");
    let out = ip;
    if (dp !== undefined) out = ip + "." + dp.slice(0, decimals);
    onValueChange(out);
  };
  return <Input type="text" inputMode="decimal" value={formatMoney(value)} onChange={handle} {...props} />;
}
